import * as types from '../constants/instrumentListConstants';
import * as commType from '../constants/commonConstants';
import * as tradepanelActions from '../actions/tradepanelActions'
import { getPath } from '../actions/commonActions';
import Socket from '../utils/socket';
import i18next from 'i18next';

let rateSocket;
let rateWebSocket;
let socketConnection = false;
let closedFromClient = false;

// function to be called for sending HB
function sendHeartbeat(ws) {
  let obj = {};
  obj.MT = "HEARTBEAT";
  ws.send(JSON.stringify(obj));
  socketConnection = true;

  // setTimeout(() => {
  //   let obj = JSON.parse(localStorage.getItem("trdPnlCmdty"));
  //   let tempArray = obj.array;
  //   if (tempArray.length !== 0) {
  //     for (let i = 0; i <= tempArray.length; i++) {
  //       subscribeTier(tempArray[i], true);
  //     }
  //   }
  // }, 2000);
}

// function to be called after opening
function callOnOpening() {
  return [
    sendHeartbeat
  ];
}

// function to be called after receiving messages
function callOnMessage(dispatch, event) {
  if (event.data !== "Invalid token") {
    dispatch(updateSocketData(event));
    dispatch(updateOpenPositions(event));
    const msg = JSON.parse(event.data);
    const BCM = msg.BCM;
    if (BCM !== undefined) {
      if (BCM === "701") {
        const obj = JSON.parse(localStorage.getItem("trdPnlCmdty"));
        let tempArray = obj.array;
        if (tempArray.length !== 0) {
          for (let i = 0; i <= tempArray.length; i++) {
            subscribeTier(tempArray[i], true);
          }
        }
      }
    }
  }
}

// function to be called after disconnection
function callOnDisconnect(dispatch) {
  dispatch(updateStatus());
  dispatch(clearHeartRateInterval());
  dispatch(
    tradepanelActions.killSessionTrader(i18next.t("sessionExpired"), false)
  );
  dispatch(tradepanelActions.killlogout());
}

// functions to be called after rate and order reconnection
function callOnReconnect(dispatch) {
  socketConnection = false;
  dispatch(updateStatus());
}

// new socket connection logic
export function loadSocket(dispatch) {
  // need to declare constants here to get non-null values
  const USER = JSON.parse(localStorage.getItem('user'));
  const PLATFORM = localStorage.getItem('platform');

  // check if user data exists
  if (USER === null) {
    dispatch(sessionTimeout());
  } else {
    // establish websocket connection
    rateSocket = new Socket();
    const rateWSParams = {
      url: getPath("rate") + '/rate/trader',
      params: [
        "neo-ws-protocol",
        "UID|" + USER.UID,
        "platform|" + PLATFORM,
        "SID|" + USER.SID,
        "CID|" + USER.location
      ]
    };
    rateWebSocket = rateSocket.connectSocket(rateWSParams, dispatch, callOnOpening, callOnMessage, callOnDisconnect, callOnReconnect);
  }
}

export function loadInstrumentList() {
  return {
    type: types.LOAD_INSTRUMENT_LIST,
    promise: (client) => client.get('/instrument_list', {})
  };
}

export function loadAllInstruments() {
  return {
    type: types.LOAD_ALL_INSTRUMENTS, 
    promise: (client) => client.get('/getAllInstruments', {})
  };
}

export function updateSocketData(message) {
  return {
    type: types.UPDATE_SOCKET_DATA,
    message
  };
}

export function updateOpenPositions(message) {
  return {
    type: commType.UPDATE_OPEN_POSITIONS,
    message
  };
}

export function subscribeTier(commodity, flag) {
  try {
    socketConnection = flag;
    if (socketConnection === true && rateWebSocket) {
      rateWebSocket = rateSocket.getSocket();
      rateWebSocket.send(JSON.stringify({ "MT": "TierSubscribe", IID: commodity }));
    } else {
      setTimeout(() => {
        if (closedFromClient === false) {
          subscribeTier(commodity, socketConnection);
        }
      }, 100);
    }
  } catch (e) {
    console.log(e);
    subscribeTier(commodity, socketConnection);
  }
  return {
    type: types.SUBSCRIBE_TIER,
  }
}

export function clearHeartRateInterval() {
  rateSocket && rateSocket.resetSocket();
  return {
    type: commType.CLEAR_KILL_SESSION,
  }
}

export function unsubscribeTier(commodity) {
  try {
    if (localStorage.getItem('logoutClose') !== 'true') {
      if (socketConnection === true && rateWebSocket) {
        rateWebSocket = rateSocket.getSocket();
        rateWebSocket.send(JSON.stringify({ "MT": "TierUnSubscribe", "IID": commodity }));
      }
      else {
        setTimeout(() => {
          if (closedFromClient === false) {
            subscribeTier(commodity);
          }
        }, 100);
      }
    }
    return {
      type: types.UNSUBSCRIBE_TIER,
    }
  } catch (e) {
    console.log(e);
  }
}

export function updateStatus() {
  return {
    type: types.UPDATE_STATUS
  };
}

export function updateFlag(flag) {

  return {
    type: types.SOCKET_FLAG,
    flag
  };
}

export function loadSocketData() {
  return (dispatch) => {
    dispatch({
      type: types.LOAD_SOCKET_DATA,
      socketData: loadSocket(dispatch)
    });
  };
}

export function closeSocketCon() {
  if (rateSocket) {
    closedFromClient = true;
    rateSocket.resetSocket();
  }
}

export function reconnectRateSocketCon(){
  closeSocketCon();
  loadSocketData();
}

export function closeSocketData() {
  return {
    type: types.CLOSE_SOCKET_DATA,
    socketData: closeSocketCon()
  };
}
//MArgin function
export function loadAccBalData(accBal, instList, neocom) {
  // console.log("hererer");
  return {
    type: types.LOAD_ACCBAL,
    accBal,
    instList,
    neocom
  };
}

export function resetStateSocket() {
  return {
    type: types.RESET_STATE_SOCKET
  }
}

export function loadAccBalMargin(acccode, UT, isOrders) {
  return {
    type:  types.LOAD_MARGIN, 
    promise: (client) => client.get(`/getMargin?accCode=${acccode}&UT=${UT}&isOrders=${isOrders}`)
  };
}

export function getMarkup() {
  return {
    type: types.LOAD_MARKUP, 
    promise: (client) => client.get(`/getStockCodeWiseMarkUp`, {})
  };
}

export function loadAllRateData(flag) {
  return {
    type: types.LOAD_ALL_RATE_DATA,
    flag
  };
}

export function loadNoMrgAccBalMargin(acccode) {
  return {
    type: types.NO_MARGIN_LOAD, 
    promise: (client) => client.get(`/getNoMarginDetails?accCode=${acccode}`)
  };
}
